import React from 'react';
import InputField from 'components/input-field';
import { useForm, useWatch } from 'react-hook-form';
import styles from './styles.module.scss';
import Text from 'components/typografy/text';
import { SquareCheckBig } from 'lucide-react';

const AccountNameForm: React.FC = () => {
  
  const {
    control,
    formState: { errors },
  } = useForm<{ paypalAccount: string }>({
    defaultValues: {
      paypalAccount: '',
    },
  });

  const emailValue = useWatch({
    control,
    name: 'paypalAccount',
  });

  const isEmailValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailValue || '');

  const startElement = (
    <div
      style={{
        width: '16px',
        height: '16px',
        minWidth: '16px',
        minHeight: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '3px',
        marginLeft: '6px',
        marginRight: '6px',
      }}
    >
      {isEmailValid ? <SquareCheckBig size={12} color="white" /> : <SquareCheckBig size={12} color="white" opacity={0.1} />}
    </div>
  );

  return (
    <div className={styles.wrapper}>
      <InputField
        name="paypalAccount"
        control={control}
        type="text"
        label="Account Address*"
        placeholder="Type your PayPal email here..."
        startElement={startElement} // 🔥 use left-side icon
        rules={{
          required: 'Email address is required.',
          pattern: {
            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: 'Please enter a valid email address.',
          },
        }}
        error={errors.paypalAccount?.message || ''}
      />

      <div className={styles.info}>
        <Text variant="small">
          We’ll send this prize to the entered email. Make sure it’s connected to your PayPal account.
        </Text>
      </div>
    </div>
  );
};

export default AccountNameForm;
